import Master from "../../layout/Master";
import Sidbar from "../../layout/Sidbar";
import Card from "../../layout/Card";  
import Post from "./Post";
import { textAlign } from "@mui/system";

    const News = () => {
        return (
            <>
                <Master>
                    <Sidbar>
                        {/* <Card> */}
                            <div className="imagePageNews">
                            <Card style={{textAlign: "center"}}>
                                <div>
                                    <input className="searchbox" placeholder="جست و جو..."/>
                                </div>
                            </Card>
                            </div>
                        {/* </Card> */}

                        <Card>
                            <div style={{width: "100%", padding: "-10"}}>
                            <div className='line'>  
                                <div style={{color: "rgb(6, 143, 125)", marginTop: "-30px", marginBottom: "10px", textAlign: "center", fontSize: "30px"}} ><b style={{background: "#fff", paddingRight: "20px", paddingLeft: "20px", zIndex: 888}}>اخبار</b></div>
                            </div>
                            </div>
                            <Post url={`image/Post/1.jpg`} title="بیماری آرتروز و هر آن‌چه که درباره آن نمی‌دانید!">
                            یکی از مشکلاتی که امروزه برخی از مردم به آن دچار هستند و این بیماری بسار خطر ساز بوده و ما باید مواظب خودمان باشیم
                            </Post>
                            <Post url={`image/Post/03.jpg`} title="علائم فشار خون بالا و راه‌های درمان آن">
                            آیا می‌دانید علائم فشار خون بالا چیست؟ فشار خون بالا بیماری‌ای است که امروزه به دلیل سبک زندگی کم‌تحرک و رژیم‌های غذایی...
                            </Post><Post url={`image/Post/0-استرس-و-افسردگی-در-دوران-کرونا.jpg`} title="افسردگی دوران کرونا و راههای مقابله با آن">
                            میزانی از استرس، نگرانی، ترس و اضطراب در زندگی نه تنها بد نیست، بلکه می‌تواند کمک‌کننده باشد و فرد را برای مقابله با تهدیدات پیش...
                            </Post>

                        </Card>
                    </Sidbar>
                </Master>
            </> 
        )
    }

    export default News;